import { FAQSlice } from '@app/common/src/types/FAQs.types'
import { FLOWCODE_MARKETING_BASE_URL, Routes } from '@dtx-company/true-common/src/constants/routes'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { FlowpageHomepageBannerProps } from '@app/page/src/containers/Homepage/HomepageBanner/types'
import { GetServerSideProps } from 'next'
import { PageContainer } from '../../components/layout'
import { PrismicPreviewData } from '@dtx-company/true-common/src/types/prismic'
import { prismicClient } from '@app/prismic/src/utils'
import { removeTrailingSlash } from '@app/common/src/hooks/useCanonicalURL'
import { setWebPageCacheControl } from '../../utils/cache'
import { useAuthRedirect } from '../../hooks/useAuthRedirect'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'
import React from 'react'
import dynamic from 'next/dynamic'
const canonical = `${removeTrailingSlash(FLOWCODE_MARKETING_BASE_URL)}${Routes.PAGE}`

/* istanbul ignore next */
const HomepageContainer = dynamic<{ data: any }>(
  () =>
    import('@app/page/src/containers/Homepage/HomepageContainer').then(
      mod => mod.HomepageContainer
    ),
  {
    // added due to hydration error
    // something downstream is accessing state before ssr is completed, like a router.push before an isReady check is made
    ssr: false
  }
)

/* istanbul ignore next */
const FlowpageHomepageBanner = dynamic<{ data: any }>(
  () =>
    import('@app/page/src/containers/Homepage/HomepageBanner/HomepageBanner').then(
      mod => mod.FlowpageHomepageBanner
    ),
  {
    // added due to hydration error
    ssr: false
  }
)

// Todo: Expand these types to safely deal with Prismic data for the Flowpage
// homepage because this data was typed as `any` from the start
type FlowpageHomepageSlices = FAQSlice

export interface FlowpageHomepageData {
  body: FlowpageHomepageSlices[]
}

export const getServerSideProps: GetServerSideProps = async ({ previewData, res }) => {
  const ref = (previewData as PrismicPreviewData)?.ref ?? ''
  const { data } = await prismicClient.getSingle('flowpage_homepage_v2', {
    ref
  })
  const { data: bannerData } = await prismicClient.getSingle('flowpage_homepage_banner', {
    ref
  })

  setWebPageCacheControl(res, 300)

  return {
    props: { data, bannerData }
  }
}

const FlowpageWelcome: React.FC<{
  data: FlowpageHomepageData
  bannerData?: FlowpageHomepageBannerProps
}> = ({ data, bannerData }) => {
  useAuthRedirect(`${removeTrailingSlash(FLOWCODE_ROOT)}${Routes.PAGES}`)

  useRedirectOnAuthChanges(false, true)

  return (
    <PageContainer disableSideNav page={Routes.PAGE} injectedMeta={{ canonical }}>
      {bannerData && <FlowpageHomepageBanner data={bannerData} />}
      <HomepageContainer data={data} />
    </PageContainer>
  )
}

export default FlowpageWelcome
